import events from 'events.js';
import http from 'http.js';
import ko from 'knockout';
import query from 'query.js';

import 'ko/elements/autocomplete.js';
import 'ko/bindings/stop_binding.js';
import 'ko/bindings/tooltip.js';

import 'common/ko/validation.js';

class DirectoryManager {
    constructor() {
        this.localitySet = ko.observable().extend({
            equal: {
                params: true,
                message: 'Please select a location from the dropdown',
            },
        });
        this.specialty = ko.observable().extend({
            required: {
                params: true,
                message: 'Please select a specialty from the dropdown',
            },
        });
        this.specialInterest = ko.observable();
        this.healthFunds = ko.observableArray();
        this.searched = ko.observable(false);
        // Only used to maintain health fund selection on initial page load
        this.selectedHealthFund = ko.observable();
        this._init = true;
        this._req = null;
        this.searchErrors = ko.validation.group([
            this.localitySet,
            this.specialty,
        ]);
    }

    async loadHealthFunds(healthFundId) {
        // If there's a pending request, cancel it before firing off a new one
        if (this._req) {
            this._req.abort();
            this._req = null;
        }
        this._req = new AbortController();
        this.healthFunds([]);

        if (!this.specialInterest() && !this.specialty()) {
            return;
        }

        const data = {
            show: document.body.dataset.searchType,
        };
        if (this.specialInterest()) {
            data.special_interest = this.specialInterest();
        } else if (this.specialty()) {
            data.specialty = this.specialty();
        }

        try {
            const response = await http.get({
                url: '/api/base/v1/health-funds/',
                data,
                signal: this._req.signal,
            });
            this.healthFunds(response);
        } catch (ex) {
            console.error('Error loading health funds');
            // pass
        }
        // Preserve selected health fund in sidebar on first load
        if (this._init) {
            this._init = false;
            const args = query.parse();
            if (healthFundId || args.health_fund) {
                let hfId = healthFundId || args.health_fund;
                try {
                    hfId = parseInt(hfId);
                } catch (ex) {
                    return;
                }
                const healthFund = this.healthFunds().find(
                    (hf) => hf.id === hfId,
                );
                if (healthFund) {
                    this.selectedHealthFund(healthFund.name);
                }
            }
        } else {
            this.selectedHealthFund(null);
        }
    }

    async load() {
        await events.ready();
        const specialty = document.getElementById('specialty-autocomplete');
        if (specialty && specialty.value) {
            this.specialty(specialty.value);
        }
        const elem = document.getElementsByClassName('js-directory-search')[0];
        // If elem wasn't found, assume we're binding to the whole page
        // which null / undefined as elem value will accomplish
        ko.applyBindings(this, elem);
        // Add 'ko-tooltip' class to any tooltip element that needs a directory binding
        for (const tooltip of document.getElementsByClassName('ko-tooltip')) {
            ko.applyBindings(this, tooltip);
        }

        const tabContainer = document.getElementById('tabs');
        if (tabContainer) {
            const tabListItems = Array.from(
                tabContainer.getElementsByTagName('li'),
            );
            const tabButtons = Array.from(
                tabContainer.getElementsByTagName('a'),
            );

            const tabShown = document.createEvent('Event');
            tabShown.initEvent('tabShown', true, true);

            for (const button of tabButtons) {
                events.listen(button, 'click', function (event) {
                    event.preventDefault();
                    for (const item of tabListItems) {
                        item.classList.remove('active');

                        const targetId = item
                            .getElementsByTagName('a')[0]
                            .getAttribute('href')
                            .substr(1);
                        const target = document.getElementById(targetId);
                        target.classList.remove('active');
                        target.style.display = 'none';
                    }
                    button.parentNode.classList.add('active');

                    const targetId = button.getAttribute('href').substr(1);
                    const target = document.getElementById(targetId);
                    target.classList.add('active');
                    document.getElementById(targetId).style.display = '';
                    button.dispatchEvent(tabShown);
                });
            }

            const form = document.querySelector('#home form');
            if (form) {
                events.listen(form, 'submit', (evt) => {
                    this.searched(true);
                    if (!this.specialty() || !this.localitySet()) {
                        evt.preventDefault();
                        this.searchErrors.showAllMessages();
                        return false;
                    }
                });
            }

            if (location.hash) {
                const hash = location.hash;
                for (const item of tabListItems) {
                    item.classList.remove('active');
                }
                const current = tabContainer.querySelectorAll(
                    `[href="${hash}"]`,
                )[0];
                // Used when '#profile' passed to DirectoryIndexView
                // to switch tabs to By Name
                if (current) {
                    current.parentNode.classList.add('active');
                    current.click();
                }
            }
        }
    }
}

// Enable auto-complete fields
new DirectoryManager().load();
